import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'matterport',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      exterior: coerceBoolean().optional(),
      floorplan: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Matterport',
    short: '',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
